import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import TicketHeaderSubtitle from './TicketHeaderSubtitle';
import TicketHeaderTitle from './TicketHeaderTitle';

interface Props {
    ticketKey: TicketKey;
}

const TicketHeaderInfo = ({ ticketKey }: Props) => (
    <div className="flex min-w-0 flex-col">
        <TicketHeaderTitle ticketKey={ticketKey} />
        <TicketHeaderSubtitle ticketKey={ticketKey} />
    </div>
);

export default React.memo(TicketHeaderInfo);
